
import {
  defineComponent,
  ref,
  onMounted,
  onUnmounted,
  onUpdated,
  PropType,
  computed,
  watch,
} from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import rowGroupHeaderModel from "@/core/models/share/timeline/rowGroupHeader.interface";
import rowHeaderModel from "@/core/models/share/timeline/rowHeader.interface";
import elmtModel from "@/core/models/share/timeline/timelineItem.interface";
import {
  IosArrowDown,
  IosArrowBack,
  IosArrowForward,
  MdArrowDropleft,
  MdArrowDropright,
} from "@vicons/ionicons4"; //https://www.xicons.org/#/

export default defineComponent({
  name: "timelineComponent",
  components: {
    IosArrowDown,
    IosArrowBack,
    IosArrowForward,
    MdArrowDropleft,
    MdArrowDropright,
  },
  props: {
    caption: { type: String },
    baseDate: { type: Date, default: new Date() },
    showWeek: { type: Number, default: 3 },
    rowGroupHeaders: {
      type: Array as PropType<Array<rowGroupHeaderModel>>,
      default: [],
      required: true,
    },
    rowHeaders: {
      type: Array as PropType<Array<rowHeaderModel>>,
      default: [],
      required: true,
    },
    eventData: {
      type: Object as PropType<Array<elmtModel>>,
      default: [],
      required: true,
    },
    tableClass: { type: String, default: "" },
    showBeforeToday: { type: Boolean, default: false },
  },
  emits: ["clickRow", "updateBasedate"],
  setup(props: any, context: any) {
    const cell = ref();
    const cellWidth = ref(Number(60));
    const showDay = props.showWeek * 7;
    const theFirstDate = computed<string>(function () {
      let result = new Date(props.baseDate);
      var day = result.getDay(),
        diff = result.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(result.setDate(diff)).toISOString();
    });
    const localRowGroupHeaders = ref<Array<rowGroupHeaderModel>>(
      props.rowGroupHeaders
    );
    const theLastDate = computed<string>(function () {
      let result = new Date(props.baseDate);
      var day = result.getDay(),
        diff = result.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(
        result.setDate(diff) + (showDay - 1) * 86400000
      ).toISOString();
    });
    const today = new Date();

    const setItemRef = function (el: any) {
      if (el) {
        cell.value = el;
      }
    };

    function dateHeaderFormat(date: Date) {
      return dayjs( date).format("YYYY/MM/DD");
    }

    function dayHeaderFormat(date: Date) {
      return dayjs( date).format("DD");
    }

    function stringColor(str: String, alpha: Boolean) {
      return str + (alpha ? "66" : "");
    }

    function eventWidth(len: number) {
      var width = len * cellWidth.value;
      return width + "px";
    }

    function localdayjs( date: Date | string) {
      return dayjs( date);
    }

    function updateTheFirstDate(date: Date) {
      context.emit("updateBasedate", date);
    }

    //Set table cell width
    function onWidthChange() {
      cellWidth.value = cell.value?.getBoundingClientRect().width!;
    }

    onMounted(() => {
      //Set table cell width
      window.addEventListener("resize", onWidthChange);
      if (cell.value)
        cellWidth.value = cell.value?.getBoundingClientRect().width!;
    });
    onUnmounted(() => {
      //Set table cell width
      window.removeEventListener("resize", onWidthChange);
    });

    onUpdated(() => {
      //當狀態被變動時，畫面已同步更新完成
      //Set table cell width
      setTimeout(() => {
        if (cellWidth.value != cell.value?.getBoundingClientRect().width!) {
          cellWidth.value = cell.value?.getBoundingClientRect().width!;
        }
      }, 500);
    });

    return {
      localRowGroupHeaders,
      cellWidth,
      cell,
      today,
      theFirstDate,
      theLastDate,
      setItemRef,
      dateHeaderFormat,
      dayHeaderFormat,
      stringColor,
      eventWidth,
      dayjs,
      updateTheFirstDate,
    };
  },
});
